import '../cli/parse.js'
const parse = window.parse
export default parse
